import { Component, type ErrorInfo, type ReactNode } from 'react';

interface Props {
	children: ReactNode;
}

interface State {
	error: Error | null;
}

/** Chặn lỗi render để cả app không trắng màn hình. */
export class ErrorBoundary extends Component<Props, State> {
	state: State = { error: null };

	static getDerivedStateFromError(error: Error): State {
		return { error };
	}

	componentDidCatch(error: Error, info: ErrorInfo) {
		console.error('[NekoStream] Lỗi render:', error, info.componentStack);
	}

	render() {
		const { error } = this.state;
		if (!error) return this.props.children;

		return (
			<div className="grid min-h-screen place-items-center p-6">
				<div className="max-w-md rounded-panel border border-dashed border-line bg-white/[0.02] p-8 text-center">
					<h1 className="mb-2 text-xl font-bold">Ứng dụng gặp sự cố</h1>
					<p className="mb-5 text-sm text-muted">{error.message}</p>
					<button
						type="button"
						onClick={() => window.location.reload()}
						className="rounded-lg bg-accent px-4 py-2 text-sm font-bold text-white"
					>
						Tải lại trang
					</button>
				</div>
			</div>
		);
	}
}
